export default __webpack_public_path__ + "static/FairplexWide-MediumItalic-1d4656bff5a84adc9ca793e732681e81.woff2";